import gql from 'graphql-tag';

export const TICKET_LIST_DETAIL_FRAGMENT = gql`
	fragment ticketList on TicketList {
		id
		driverItems {
			id
			notResolved
			notResolvedComment
			ticket {
				id
				identifier
				description
				status
				visibleToDrivers
				photoRequired
				ticketWorkflowStatus
				ticketAssignmentCategory

				assignee {
					id
					firstname
					lastname
					destroyed
				}

				creator {
					id
					firstname
					lastname
					destroyed
				}

				notes {
					id
					description
					isAdminNote
					creator {
						id
						firstname
						destroyed
					}
				}
				imageUrls
				repairWorkCarriedOut
				repairPartsUsed
				repairOutcome
				repairCompletedByName
				repairCompletedAt
				repairReportUrl

				timeSpent
				timeSpentUnit
				labourCost
				partsCost
			}
		}
	}
`;

export const GET_TICKET_LIST_DETAIL = gql`
	query($id: String) {
		getTicketList(id: $id) {
			...ticketList
		}
	}
	${TICKET_LIST_DETAIL_FRAGMENT}
`;
